import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AtualizarCustosResultDto, CustoItemDto } from '../../models/produtos/atualizar-custos-resultado';

import { Produto } from '../../models/produtos/produto';
import { ProdutoCampanha } from '../../models/produtos/produto-campanha';
import { ProdutoCampanhaCliente } from '../../models/produtos/produto-campanha-cliente';
import { ProdutoCampanhaItens } from '../../models/produtos/produto-campanha-itens';
import { ProdutoCampanhaVendedor } from '../../models/produtos/produto-campanha-vendedor';
import { ProdutoCesta } from '../../models/produtos/produto-cesta';
import { ProdutoDesconto } from '../../models/produtos/produto-desconto';
import { ProdutoEspecialCliente } from '../../models/produtos/produto-especial-cliente';
import { ProdutoEspecialVendedor } from '../../models/produtos/produto-especial-vendedor';
import { ProdutoFichaTecnica } from '../../models/produtos/produto-ficha-tecnica';
import { ProdutoFoto } from '../../models/produtos/produto-foto';
import { ProdutoLote } from '../../models/produtos/produto-lote';
import { ProdutoPromocional } from '../../models/produtos/produto-promocional';
import { ProdutoReferenciaCliente } from '../../models/produtos/produto-referencia-cliente';
import { ProdutoSegmento } from '../../models/produtos/produto-segmento';
import { ProdutoSimilar } from '../../models/produtos/produto-similar';
import { ProdutoTabelaEspecialItens } from '../../models/produtos/produto-tabela-especial-itens';
import { ProdutoTabelaEspecial } from '../../models/produtos/produto-tabela-especial';
import { ProdutoTabela } from '../../models/produtos/produto-tabela';
import { ProdutoLocal } from '../../models/produtos/produto-local';
import { PromoRegraGrupo } from '../../models/produtos/promo-regra-grupo';

@Injectable({
  providedIn: 'root'
})

export class ProdutoService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  /* Produto */

  public addMultiplos(produtos: Produto[]): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtos": produtos
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/AddMultiplos", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getByGuidClienteNapis(): Observable<Produto[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<Produto[]>(this.baseUrl + "api/Produto/GetByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getFiltroOpcoes(): Observable<{ marcas: string[]; subgrupos1: string[]; subgrupos2: string[]; subgrupos3: string[]; subgrupos4: string[]; subgrupos5: string[] }> {
    this.headers.set("Content-Type", "application/json");

    let data = { "guidclientenapis": localStorage.getItem("guidclientenapis") };

    return this.http.post<any>(this.baseUrl + "api/Produto/GetFiltroOpcoes", data, { headers: this.headers }).pipe(
      catchError(() => of({ marcas: [], subgrupos1: [], subgrupos2: [], subgrupos3: [], subgrupos4: [], subgrupos5: [] }))
    );
  }

  public searchPaged(filtros: { tipo: string; valor: string }[], page: number = 0, pageSize: number = 500): Observable<{ items: Produto[]; total: number; page: number; pageSize: number }> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "filtros": filtros,
      "page": page,
      "pageSize": pageSize
    };

    return this.http.post<{ items: Produto[]; total: number; page: number; pageSize: number }>(this.baseUrl + "api/Produto/SearchPaged", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of({ items: [], total: 0, page: 0, pageSize });
      })
    );
  }

  public getById(id: number): Observable<Produto> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<Produto>(this.baseUrl + "api/Produto/GetById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public getByUsuarioCliente(id_cliente: number): Observable<Produto[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "id_cliente": id_cliente
    };

    return this.http.post<Produto[]>(this.baseUrl + "api/Produto/GetByUsuarioCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getGrupoEstoqueByGuidClienteNapis(): Observable<string[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<string[]>(this.baseUrl + "api/Produto/GetGrupoEstoqueByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public updateFichaTecnica(produto: Produto): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produto": produto
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdateFichaTecnica", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateMostrarB2BById(id: number, liberar: boolean): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "liberar": liberar
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdateMostrarB2BById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updatePromocaoById(id: number, definir: boolean): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "definir": definir
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdatePromocaoById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public atualizarProdutoSapServiceLayer(id: number): Observable<any> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<any>(this.baseUrl + "api/Produto/AtualizarProdutoSapServiceLayer", data, { headers: this.headers }).pipe(
      catchError((err) => {
        let mensagem = "Houve um erro ao atualizar o produto TR.";

        if (err.error != null) {
          if (err.error.erro != null) {
            mensagem = err.error.erro;
          } else if (err.error.mensagem != null) {
            mensagem = err.error.mensagem;
          } else if (err.error.message != null) {
            mensagem = err.error.message;
          }
        }

        this.toastr.error("", mensagem);

        return of(null);
      })
    );
  }

  /* Produto (Campanha (Itens)) */

  public addProdutoCampanhaCliente(produtoCampanhaCliente: ProdutoCampanhaCliente): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    const data = {
      "produtoCampanhaCliente": produtoCampanhaCliente
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoCampanhaCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public deleteProdutoCampanhaClienteById(id_produto_campanha_cliente: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    const data = {
      "id_produto_campanha_cliente": id_produto_campanha_cliente
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/DeleteProdutoCampanhaClienteById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getProdutoCampanhaClienteByIdCampanha(id_campanha: number): Observable<ProdutoCampanhaCliente[]> {
    this.headers.set("Content-Type", "application/json");

    const data = {
      "id_campanha": id_campanha
    };

    return this.http.post<ProdutoCampanhaCliente[]>(this.baseUrl + "api/Produto/GetProdutoCampanhaClienteByIdCampanha", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getProdutoCampanhaItensByIdCampanha(id_campanha: number): Observable<ProdutoCampanhaItens[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_campanha": id_campanha,
      "ativo": false,
      "mostrar_b2b": false
    };

    return this.http.post<ProdutoCampanhaItens[]>(this.baseUrl + "api/Produto/GetProdutoCampanhaItensByIdCampanha", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public updateProdutoCampanhaItens(id_campanha: number, produtoCampanhaItens: ProdutoCampanhaItens[]): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_campanha": id_campanha,
      "produtoCampanhaItens": produtoCampanhaItens
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdateProdutoCampanhaItens", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public addProdutoCampanhaVendedor(produtoCampanhaVendedor: ProdutoCampanhaVendedor): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    const data = {
      "produtoCampanhaVendedor": produtoCampanhaVendedor
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoCampanhaVendedor", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public deleteProdutoCampanhaVendedorById(id_produto_campanha_vendedor: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    const data = {
      "id_produto_campanha_vendedor": id_produto_campanha_vendedor
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/DeleteProdutoCampanhaVendedorById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getProdutoCampanhaVendedorByIdCampanha(id_campanha: number): Observable<ProdutoCampanhaVendedor[]> {
    this.headers.set("Content-Type", "application/json");

    const data = {
      "id_campanha": id_campanha
    };

    return this.http.post<ProdutoCampanhaVendedor[]>(this.baseUrl + "api/Produto/GetProdutoCampanhaVendedorByIdCampanha", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Campanha) */

  public addProdutoCampanha(produtoCampanha: ProdutoCampanha): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoCampanha": produtoCampanha,
      "seller_id": parseInt(localStorage.getItem("id") || "0")
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoCampanha", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public getProdutoCampanhaByGuidClienteNapis(): Observable<ProdutoCampanha[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "ativo": false
    };

    return this.http.post<ProdutoCampanha[]>(this.baseUrl + "api/Produto/GetProdutoCampanhaByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getProdutoCampanhaById(id_campanha: number): Observable<ProdutoCampanha> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_campanha": id_campanha
    };

    return this.http.post<ProdutoCampanha>(this.baseUrl + "api/Produto/GetProdutoCampanhaById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public updateProdutoCampanha(produtoCampanha: ProdutoCampanha): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoCampanha": produtoCampanha,
      "seller_id": parseInt(localStorage.getItem("id") || "0")
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdateProdutoCampanha", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  /* Produto (Cesta) */

  public getProdutoCestaByGuidClienteNapis(segmento: string): Observable<ProdutoCesta[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "segmento": segmento
    };

    return this.http.post<ProdutoCesta[]>(this.baseUrl + "api/Produto/GetProdutoCestaByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Desconto) */

  public getDescontoByProduto(id_cliente: number, id_produto: number, preco: number, qtde: number, id_vendedor: number, id_lote: number, valor_fator_financeiro_tabela: number, id_prazo: number = null, preco_sem_fator: number = null, propagarErro = false): Observable<ProdutoDesconto> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_cliente": id_cliente,
      "id_produto": id_produto,
      "preco": preco,
      "qtde": qtde,
      "id_vendedor": id_vendedor,
      "id_lote": id_lote,
      "valor_fator_financeiro_tabela": valor_fator_financeiro_tabela,
      "id_prazo": id_prazo,
      "preco_sem_fator": preco_sem_fator
    };

    return this.http.post<ProdutoDesconto>(this.baseUrl + "api/Produto/GetDescontoByProduto", data, { headers: this.headers, reportProgress: true }).pipe(
      catchError(error => {
        if (propagarErro) return throwError(() => error);
        this.toastr.error("", "Houve um erro, contate o suporte...");

        let produtoDesconto: ProdutoDesconto = new ProdutoDesconto();

        produtoDesconto.desconto_concedido = 0;
        produtoDesconto.descritivo_desconto = "";

        return of(produtoDesconto);
      })
    );
  }

  /* Produto Especial (Cliente) */

  public addProdutoEspecialCliente(produtoEspecialCliente: ProdutoEspecialCliente): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoEspecialCliente": produtoEspecialCliente
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoEspecialCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public deleteProdutoEspecialClienteById(id_produto_especial_cliente: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto_especial_cliente": id_produto_especial_cliente
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/DeleteProdutoEspecialClienteById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getProdutoEspecialClienteByIdProdutoTabelaEspecial(id_produto_tabela_especial: number): Observable<ProdutoEspecialCliente[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto_tabela_especial": id_produto_tabela_especial
    };

    return this.http.post<ProdutoEspecialCliente[]>(this.baseUrl + "api/Produto/GetProdutoEspecialClienteByIdProdutoTabelaEspecial", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto Especial (Vendedor) */

  public addProdutoEspecialVendedor(produtoEspecialVendedor: ProdutoEspecialVendedor): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoEspecialVendedor": produtoEspecialVendedor
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoEspecialVendedor", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public deleteProdutoEspecialVendedorById(id_produto_especial_vendedor: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto_especial_vendedor": id_produto_especial_vendedor
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/DeleteProdutoEspecialVendedorById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getProdutoEspecialVendedorByIdProdutoTabelaEspecial(id_produto_tabela_especial: number): Observable<ProdutoEspecialVendedor[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto_tabela_especial": id_produto_tabela_especial
    };

    return this.http.post<ProdutoEspecialVendedor[]>(this.baseUrl + "api/Produto/GetProdutoEspecialVendedorByIdProdutoTabelaEspecial", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public syncProdutoEspecialVendedores(id_produto_tabela_especial: number, id_vendedores: number[]): Observable<ProdutoEspecialVendedor[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto_tabela_especial": id_produto_tabela_especial,
      "id_vendedores": id_vendedores
    };

    return this.http.post<ProdutoEspecialVendedor[]>(this.baseUrl + "api/Produto/SyncProdutoEspecialVendedores", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Ficha Técnica) */

  public addFichaTecnica(produtoFichaTecnica: ProdutoFichaTecnica): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoFichaTecnica": produtoFichaTecnica
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddFichaTecnica", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public deleteFichaTecnicaById(id: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/DeleteFichaTecnicaById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getFichaTecnicaByIdProduto(id_produto: number): Observable<ProdutoFichaTecnica[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto": id_produto
    };

    return this.http.post<ProdutoFichaTecnica[]>(this.baseUrl + "api/Produto/GetFichaTecnicaByIdProduto", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Foto) */

  public addProdutoFoto(produtoFoto: ProdutoFoto): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoFoto": produtoFoto
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoFoto", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public deleteProdutoFotoById(id: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/DeleteProdutoFotoById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getProdutoFotosByIdProduto(id_produto: number): Observable<ProdutoFoto[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto": id_produto
    };

    return this.http.post<ProdutoFoto[]>(this.baseUrl + "api/Produto/GetProdutoFotosByIdProduto", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getProdutoFotosByIds(ids: number[]): Observable<ProdutoFoto[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "ids": ids
    };

    return this.http.post<ProdutoFoto[]>(this.baseUrl + "api/Produto/GetProdutoFotosByIds", data, { headers: this.headers }).pipe(
      catchError(() => of([]))
    );
  }

  public updatePadraoById(id: number, id_produto: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "id_produto": id_produto
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdatePadraoById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  /* Produto (Local) */

  public getProdutoLocalByIdProduto(id_produto: number): Observable<ProdutoLocal[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto": id_produto
    };

    return this.http.post<ProdutoLocal[]>(this.baseUrl + "api/Produto/GetProdutoLocalByIdProduto", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getProdutoLocalByGuidClienteNapis(): Observable<ProdutoLocal[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<ProdutoLocal[]>(this.baseUrl + "api/Produto/GetProdutoLocalByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Lote) */

  public getProdutoLoteByIdProduto(id_produto: number, nome_lote: string, id_cliente: number, id_forma_pagamento: number): Observable<ProdutoLote[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "id_produto": id_produto,
      "nome_lote": nome_lote,
      "id_cliente": id_cliente,
      "id_forma_pagamento": id_forma_pagamento
    };

    return this.http.post<ProdutoLote[]>(this.baseUrl + "api/Produto/GetProdutoLoteByIdProduto", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Promocional) */

  public getProdutoPromocionalByGuidClienteNapis(client_id_app: number, nome_lote: string, id_forma_pagamento: number, id_prazo_pagamento?: number): Observable<ProdutoPromocional[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "mostrar_b2b": false,
      "client_id_app": client_id_app,
      "seller_id": localStorage.getItem("id"),
      "nome_lote": nome_lote,
      "id_forma_pagamento": id_forma_pagamento,
      "id_prazo_pagamento": id_prazo_pagamento
    };

    return this.http.post<ProdutoPromocional[]>(this.baseUrl + "api/Produto/GetProdutoPromocionalByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Referência) */

  public getReferenciaClienteByGuidClienteNapis(): Observable<ProdutoReferenciaCliente[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<ProdutoReferenciaCliente[]>(this.baseUrl + "api/Produto/GetReferenciaClienteByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Segmento) */

  public addProdutoSegmento(produtoSegmento: ProdutoSegmento): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoSegmento": produtoSegmento
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoSegmento", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public deleteProdutoSegmentoById(id: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/DeleteProdutoSegmentoById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getProdutoSegmentoByIdProduto(id_produto: number): Observable<ProdutoSegmento[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto": id_produto
    };

    return this.http.post<ProdutoSegmento[]>(this.baseUrl + "api/Produto/GetProdutoSegmentoByIdProduto", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Similar) */

  public getProdutoSimilarByGuidClienteNapis(): Observable<ProdutoSimilar[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<ProdutoSimilar[]>(this.baseUrl + "api/Produto/GetProdutoSimilarByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Produto (Tabela Especial (Itens)) */

  public getProdutoTabelaEspecialItensByIdProdutoTabelaEspecial(id_produto_tabela_especial: number): Observable<ProdutoTabelaEspecialItens[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto_tabela_especial": id_produto_tabela_especial,
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<ProdutoTabelaEspecialItens[]>(this.baseUrl + "api/Produto/GetProdutoTabelaEspecialItensByIdProdutoTabelaEspecial", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public updateProdutoTabelaEspecialItens(produtoTabelaEspecialItens: ProdutoTabelaEspecialItens[]): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoTabelaEspecialItens": produtoTabelaEspecialItens
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdateProdutoTabelaEspecialItens", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  /* Produto (Tabela Especial) */

  public addProdutoTabelaEspecial(produtoTabelaEspecial: ProdutoTabelaEspecial): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoTabelaEspecial": produtoTabelaEspecial,
      "seller_id": parseInt(localStorage.getItem("id") || "0")
    };

    return this.http.post<number>(this.baseUrl + "api/Produto/AddProdutoTabelaEspecial", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(0);
      })
    );
  }

  public getProdutoTabelaEspecialByGuidClienteNapis(): Observable<ProdutoTabelaEspecial[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<ProdutoTabelaEspecial[]>(this.baseUrl + "api/Produto/GetProdutoTabelaEspecialByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getProdutoTabelaEspecialById(id_produto_tabela_especial: number): Observable<ProdutoTabelaEspecial> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_produto_tabela_especial": id_produto_tabela_especial
    };

    return this.http.post<ProdutoTabelaEspecial>(this.baseUrl + "api/Produto/GetProdutoTabelaEspecialById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public updateProdutoTabelaEspecial(produtoTabelaEspecial: ProdutoTabelaEspecial): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "produtoTabelaEspecial": produtoTabelaEspecial,
      "seller_id": parseInt(localStorage.getItem("id") || "0")
    };

    return this.http.post<boolean>(this.baseUrl + "api/Produto/UpdateProdutoTabelaEspecial", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  /* Custo (via SAPB1Connector) */

  public atualizarCustosExcel(atualizarpromocoes: string, itens: CustoItemDto[]): Observable<AtualizarCustosResultDto> {
    this.headers.set("Content-Type", "application/json");

    const data = { atualizarpromocoes, itens };

    return this.http.post<AtualizarCustosResultDto>(this.baseUrl + "api/Produto/AtualizarCustosExcel", data, { headers: this.headers }).pipe(
      catchError((err) => {
        this.toastr.error("", "Houve um erro ao processar os custos. Contate o suporte.");
        return throwError(() => err);
      })
    );
  }

  /* Produto (Tabela) */

  public getTabelaByProduto(id_cliente: number, id_vendedor: number, id_produto: number, id_lote: number, id_prazo_pagamento: number, propagarErro = false): Observable<ProdutoTabela[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_cliente": id_cliente,
      "id_vendedor": id_vendedor,
      "id_produto": id_produto,
      "id_lote": id_lote,
      "id_prazo_pagamento": id_prazo_pagamento
    };

    return this.http.post<ProdutoTabela[]>(this.baseUrl + "api/Produto/GetTabelaByProduto", data, { headers: this.headers }).pipe(
      catchError((error) => {
        if (propagarErro) return throwError(() => error);
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Promo Regra Grupo */

  public getRegraGrupos(promo_id: number, promo_tipo: string, guidclientenapis: string): Observable<PromoRegraGrupo[]> {
    return this.http.post<PromoRegraGrupo[]>(`${this.baseUrl}api/Produto/GetRegraGrupos`, { promo_id, promo_tipo, guidclientenapis })
      .pipe(catchError(() => { this.toastr.error('', 'Erro ao carregar regras!'); return of([]); }));
  }

  public addRegraGrupo(regra: PromoRegraGrupo): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}api/Produto/AddRegraGrupo`, regra)
      .pipe(catchError(() => { this.toastr.error('', 'Erro ao adicionar regra!'); return of(false); }));
  }

  public deleteRegraGrupo(id: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}api/Produto/DeleteRegraGrupo`, { id })
      .pipe(catchError(() => { this.toastr.error('', 'Erro ao remover regra!'); return of(false); }));
  }

  public getValoresDistintos(entidade: string, campo: string, guidclientenapis: string): Observable<string[]> {
    return this.http.post<string[]>(`${this.baseUrl}api/Produto/GetValoresDistintos`, { entidade, campo, guidclientenapis })
      .pipe(catchError(() => { this.toastr.error('', 'Erro ao carregar valores!'); return of([]); }));
  }
}
